function formatDuration(durationInSeconds: number) {
  const hours = Math.floor(durationInSeconds / 3600);
  const minutes = Math.round((durationInSeconds % 3600) / 60);
  return `${hours ? `${hours}h ` : ''}${minutes}m`;
}

export default formatDuration;
